import { useState, useEffect, useRef } from "react";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  Alert,
  Modal,
  Table,
} from "react-bootstrap";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import { Navigate, Link, useNavigate } from "react-router-dom";
import {
  setLoader,
  setToken,
  setUser,
  setLogo,
  setSub,
} from "action/index.js";
import useToast from "hooks/useToast";
import SimpleReactValidator from "simple-react-validator";
import "components/custom.css";
import { Helmet } from "react-helmet";
import "react-datepicker/dist/react-datepicker.css";
import API from "api.js";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import LaLoader from "components/Loader/LaLoader.jsx";

const Register = (props) => {
  const { executeRecaptcha } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);
  const { showToast } = useToast();
  const handleSetToken = (tok) => dispatch(setToken(tok));
  const handleSetUser = (user) => dispatch(setUser(user));

  const handleSetLogo = (sub) => dispatch(setLogo(sub));

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [cpasswordVisible, setCPasswordVisible] = useState(false);
  const [isCPasswordFocused, setIsCPasswordFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [countryState, setCountryState] = useState("");
  const [dob, setDob] = useState("");
  const [dobs, setDobs] = useState("");
  const [center, setCenter] = useState("");
  const [score, setScore] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [isInstitude, setIsInstitude] = useState(true);
  const [login, setLogin] = useState(false);
  const [modal, setModal] = useState(false);
  const [errorBag, setErrorBag] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [country_citizenship, setCountry_citizenship] = useState("");
  const [country_residence, setCountry_residence] = useState("");
  const [show, setShow] = useState(false);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);
  const [loading, setLoading] = useState(false);

  const changeInput = (setter) => (e) => {
    setter(e.target.value);

    setFieldErrors((prev) => ({
      ...prev,
      [e.target.name]: null,
    }));
  };

  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        alpha_space: "Allowed only letters and spaces.",
      },
      validators: {
        firstnameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "First Name is required",
        },
        lastnameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Last Name is required",
        },
        emailMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Email is required",
        },
        emailValid: {
          rule: (val) => {
            if (!val) return false;
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(val);
          },
          message: "Please enter a valid email address",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        passMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Password is required",
        },
        passwordStrong: {
          rule: (val) => {
            if (!val) return false;
            const regex =
              /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
            return regex.test(val);
          },
          message:
            "Password must be at least 6 characters and include 1 uppercase letter, 1 number, and 1 special character",
        },
        cpassMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Confirm Password is required",
        },
        passwordMatch: {
          rule: (val) => val === password, // 🔥 use hook state directly
          required: true,
          message: "Passwords do not match.",
        },
      },
    })
  );
  // Ensure the validator has the current password for the match rule to avoid stale closures
  validator.current.rules.passwordMatch.rule = (val) => val === password;


  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible((prev) => !prev);
  };

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    if (token && token !== "null") {
      navigate("/admin/dashboard");
    }
  }, [token, navigate]);

  useEffect(() => {
    if (errorBag) {
      const timer = setTimeout(() => {
        setErrorBag(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [errorBag]);

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  const sendOTP = async (e) => {
    e.preventDefault();
    console.log("phone", phone);

    if (loading) {
      return;
    }
    setLoading(true);

    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate();
      setLoading(false);
      return;
    }

    if (!executeRecaptcha) {
      showToast({ type: 2, message: "Captcha not ready. Please try again." });
      setLoading(false);
      return;
    }

    let recaptchaToken = "";
    try {
      recaptchaToken = await executeRecaptcha("otp_action");
    } catch (err) {
      showToast({ type: 2, message: "Captcha verification failed." });
      setLoading(false);
      return;
    }

    const bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("password", password);
    bodyFormData.set("user_name", userName);
    bodyFormData.set("center", isInstitude ? center : "");
    bodyFormData.set("phone", phone);
    bodyFormData.set("score", score);
    bodyFormData.set("first_name", firstName);
    bodyFormData.set("last_name", lastName);
    bodyFormData.set("dob", dob);
    bodyFormData.set("country_citizenship", country_citizenship);
    bodyFormData.set("country_residence", country_residence);
    bodyFormData.set("country_state", countryState);
    bodyFormData.set("recaptcha_token", recaptchaToken);

    try {
      const res = await API({
        method: "POST",
        url: "/send/otp",
        data: bodyFormData,
      });

      if (res.status === 200) {
        setIsOtp(true);
        setErrorBag(null);

        showToast({
          type: 1,
          message: "Please check your email for verification code.",
        });

      }
    } catch (error) {
      console.error("Send OTP Error:", error);

      if (error.response?.status === 422) {
        setFieldErrors(error.response.data.errors || {});
      } else if (error.response) {
        showToast({ type: 2, message: "Something went wrong. Please try again." });
      } else {
        showToast({ type: 2, message: "Network error. Please check your internet connection." });
      }
    } finally {
      setLoading(false);
    }
  };

  const facebookSignUp = (response) => {
    console.log(response);

    API({
      method: "POST",
      url: "/fbSignUp",
      data: response,
    })
      .then((res) => {
        console.log(res);
        afterRequest(res);
      })
      .catch(() => {
        showToast({ type: 2, message: "Something went wrong. Please try again later." });
      });
  };

  const googleSignUp = (credentialResponse) => {
    dispatch(setLoader(false));

    API({
      method: "POST",
      url: "/googleSignUp",
      data: credentialResponse,
    })
      .then((res) => {
        console.log(res);
        afterRequest(res);
      })
      .catch(() => {
        showToast({ type: 2, message: "Something went wrong. Please try again later." });
      });
  };

  const afterRequest = (res) => {
    if (res?.status === 200) {
      handleSetToken(res.data.original.access_token);
      handleSetUser(res.data.original.user);
      handleSetLogo(res.data.original.image);
      setLogin(true);
    } else if (res?.response?.status === 402) {
      showToast({ type: 2, message: "Something went wrong. Please try again later." });
    }
  };

  const sendOTP1 = async (e) => {
    try {
      e.preventDefault();
      setErrorBag(null);

      if (loading) {
        return;
      }
      setLoading(true);
      if (!executeRecaptcha) {
        showToast({ type: 2, message: "Captcha not ready. Please try again." });
        setLoading(false);
        return;
      }
      let recaptchaToken = "";
      try {
        recaptchaToken = await executeRecaptcha("otp_action");
      } catch (err) {
        showToast({ type: 2, message: "Captcha verification failed." });
        setLoading(false);
        return;
      }
      const bodyFormData = new FormData();
      bodyFormData.set("email", email);
      bodyFormData.set("user_name", userName);
      bodyFormData.set("password", password);
      bodyFormData.set("center", isInstitude ? center : "");
      bodyFormData.set("phone", phone);
      bodyFormData.set("score", score);
      bodyFormData.set("first_name", firstName);
      bodyFormData.set("last_name", lastName);
      bodyFormData.set("dob", dob);
      bodyFormData.set("country_citizenship", country_citizenship);
      bodyFormData.set("country_residence", country_residence);
      bodyFormData.set("country_state", countryState);
      bodyFormData.set("recaptcha_token", recaptchaToken);
      console.log("res2");

      const res = await API({
        method: "POST",
        url: "/send/otp",
        data: bodyFormData,
      });
      console.log("res");
      if (res.status === 200) {
        setIsOtp(true);

        showToast({
          type: 1,
          message: "Please check your email for verification code.",
        })

      }
    } catch (error) {
      if (error.response?.status === 422) {
        // Shown inline
      } else {
        showToast({ type: 2, message: "Something went wrong. Please try again later." });
      }
    } finally {
      setLoading(false);
    }
  };

  const postSignUp = async (e) => {
    if (loading) {
      return;
    }
    setLoading(true);
    e.preventDefault();

    if (!executeRecaptcha) {
      showToast({ type: 2, message: "Captcha not ready" });
      setLoading(false);
      return;
    }

    let recaptchaToken = "";
    try {
      recaptchaToken = await executeRecaptcha("signup_action");
    } catch {
      showToast({ type: 2, message: "Captcha error" });
      setLoading(false);
      return;
    }

    if (!otp || otp.length !== 10) {
      validator.current.showMessageFor("otp");
      forceUpdate();
      setLoading(false);
      return;
    }

    setErrorBag(null);

    const bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("password", password);
    bodyFormData.set("phone", phone);
    bodyFormData.set("first_name", firstName);
    bodyFormData.set("last_name", lastName);
    bodyFormData.set("otp", otp);
    bodyFormData.set("recaptcha_token", recaptchaToken);

    try {
      const res = await API({
        method: "POST",
        url: "/signup",
        data: bodyFormData,
      });

      if (res.status === 200) {
        setLogin(true);

        handleSetToken(res.data.data.access_token);
        handleSetUser(res.data.data.user);
        handleSetLogo(res.data.data.image);




        showToast({ type: 1, message: res.data.message });
      } else if (res.status === 202) {
        showToast({ type: 2, message: res.data.message });
      }
      setLoading(false);
    } catch (error) {
      const resp = error?.response;
      showToast({ type: 2, message: `${resp?.data?.message || "Something went wrong. Please try again."}` });
      setLoading(false);
    }
  };

  const toggleModal = () => {
    setModal((prev) => !prev);
  };

  const changeCheckInput = () => {
    setIsInstitude((prev) => !prev);
  };

  const changeDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    const formatted = [year, month, day].join("-");

    console.log(formatted);

    setDob(formatted);
    setDobs(date);
  };

  const selectCountry = (val) => {
    setCountry_citizenship(val);
  };

  const selectCountryResidence = (val) => {
    setCountry_residence(val);
    setCountryState(""); // clear state as per class version
  };

  const selectRegion = (val) => {
    setCountryState(val);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (login) {
    return <Navigate to="/register-success" replace />;
  }

  return (
    <>
      <Helmet>
        <title>LA Language Academy Registration | Join Us Today</title>
        <meta name="description" content="Register your free account now at LA Language Academy to obtain your Free Mock Test Material." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/auth/register`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="LA Language Academy Registration | Join Us Today" />
        <meta name="twitter:description" content="Register your free account now at LA Language Academy to obtain your Free Mock Test Material." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/auth/register`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="LA Language Academy Registration | Join Us Today" />
        <meta property="og:description" content="Register your free account now at LA Language Academy to obtain your Free Mock Test Material." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="register-page">
        <LaLoader show={loading} />
        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Body>
            <Table>
              <tbody>
                <tr>
                  <td>
                    Person Aiming for 5 bands, if he get 36 in overall in full
                    mock test, or 30+ in reading test or 50+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 5.5 bands, if he get 42 in overall in full
                    mock test, or 30+ in reading test or 55+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 6 bands, if he get 46 in overall in full
                    mock test, or 35+ in reading test or 50+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 6.5 bands, if he get 50 in overall in full
                    mock test, or 40+ in reading test or 55+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 7 bands, if he get 55 in overall in full
                    mock test, or 45+ in reading test or 65+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 7.5 bands, if he get 62 in overall in full
                    mock test, or 50+ in reading test or 70+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
                <tr>
                  <td>
                    Person Aiming for 8 bands, if he get 68+ in overall in full
                    mock test, or 55+ in reading test or 75+ in listening mock
                    then select this option in dropdown.
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="form-page-wrapper account-wrapper mt-80">
          <div className="form-header">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="text-center">
                    <h2 className="primary-heading">
                      Create <br className="d-block d-md-none" />{" "}
                      <span className="wpl-badge pte-naati-badge text-white">
                        an Account
                      </span>
                    </h2>
                    <p className="sub-heading bold-sub-heading">
                      Register now to obtain your free Mock Test Material
                    </p>
                  </div>
                  <div className="form-content-outer position-relative">
                    <div className="form-content">
                      <div className="form-img">
                        <img
                          className="img-fluid"
                          src="/images/web-new-images/hero_img-02.png"
                          alt="LA"
                        />
                      </div>
                      <div className="form-content-right">
                        {!isOtp ? (
                          <div className="contentOuter">
                            <div className="col-sm-12 registerForm">
                              <div className="row">
                                <div className="fieldOuter">
                                  <h2 className="form-content-heading">
                                    Fill in your details
                                  </h2>
                                </div>

                                <div className="fieldOuter">
                                  <label htmlFor="firstName">First Name*</label>

                                  <div className="form-input-outer">
                                    <input
                                      id="firstName"
                                      className="form-input"
                                      placeholder="Enter First Name"
                                      type="text"
                                      name="firstName"
                                      autoComplete="off"
                                      autoCapitalize="none"
                                      spellCheck={false}
                                      value={firstName}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[A-Za-z ]*$/.test(value)) {
                                          changeInput(setFirstName(value));
                                        }
                                      }}
                                      onPaste={(e) => {
                                        if (
                                          /[^A-Za-z ]/.test(
                                            e.clipboardData.getData("text")
                                          )
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </div>

                                  {validator.current.message(
                                    "First Name",
                                    firstName,
                                    "firstnameMatch"
                                  )}
                                </div>

                                <div className="fieldOuter">
                                  <label htmlFor="lastName">Last Name*</label>

                                  <div className="form-input-outer">
                                    <input
                                      id="lastName"
                                      className="form-input"
                                      placeholder="Enter Last Name"
                                      type="text"
                                      name="lastName"
                                      autoComplete="off"
                                      autoCapitalize="none"
                                      spellCheck={false}
                                      value={lastName}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[A-Za-z ]*$/.test(value)) {
                                          changeInput(setLastName(value));
                                        }
                                      }}
                                      onPaste={(e) => {
                                        if (
                                          /[^A-Za-z ]/.test(
                                            e.clipboardData.getData("text")
                                          )
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </div>

                                  {validator.current.message(
                                    "Last Name",
                                    lastName,
                                    "lastnameMatch"
                                  )}
                                </div>
                              </div>

                              <div className="fieldOuter">
                                <label htmlFor="Email">Email*</label>

                                <div className="form-input-outer">
                                  <input
                                    id="Email"
                                    className="form-input"
                                    placeholder="Enter Email"
                                    type="email"
                                    name="email"
                                    autoComplete="off"
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    value={email}
                                    onChange={changeInput(setEmail)}
                                  />
                                </div>

                                {validator.current.message(
                                  "Email",
                                  email,
                                  "emailMatch|emailValid"
                                )}

                                {fieldErrors?.email && (
                                  <div
                                    style={{
                                      color: "#d32f2f",
                                      fontSize: "12px",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {fieldErrors.email[0]}
                                  </div>
                                )}
                              </div>

                              <div className="fieldOuter">
                                <label htmlFor="phonenumber">
                                  Phone Number *
                                </label>

                                <PhoneInputField
                                  id="phonenumber"
                                  placeholder="Phone Number"
                                  value={phone}
                                  changeEvent={handlePhoneChange}
                                  onDialCodeStatusChange={(status) =>
                                    setIsDialCodeSelected(status)
                                  }
                                />
                                {phone === ""
                                  ? validator.current.message(
                                    "Enter Phone Number",
                                    phone,
                                    "phoneMatch"
                                  )
                                  : !isDialCodeSelected
                                    ? validator.current.message(
                                      "Enter Phone Number",
                                      phone,
                                      "dialCodeRequired"
                                    )
                                    : validator.current.message(
                                      "Enter Phone Number",
                                      phone,
                                      "phoneValid"
                                    )}

                                {fieldErrors?.phone && (
                                  <div
                                    style={{
                                      color: "#d32f2f",
                                      fontSize: "12px",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {fieldErrors.phone[0]}
                                  </div>
                                )}
                              </div>

                              <div className="fieldOuter">
                                <label htmlFor="Password">Password*</label>

                                <div className="form-input-outer password-field">
                                  <input
                                    id="Password"
                                    className="form-input"
                                    placeholder="Password"
                                    type={passwordVisible ? "text" : "password"}
                                    name="password"
                                    autoComplete="new-password"
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    value={password}
                                    onFocus={() => {
                                      setIsPasswordFocused(true);
                                      validator.current.showMessageFor(
                                        "Password"
                                      );
                                    }}
                                    onBlur={() => setIsPasswordFocused(false)}
                                    onChange={(e) => {
                                      changeInput(setPassword)(e);
                                      validator.current.showMessageFor(
                                        "Password"
                                      );
                                    }}
                                  />

                                  <button
                                    type="button"
                                    className="password-toggle"
                                    aria-label={passwordVisible ? "Hide password" : "Show password"}
                                    aria-pressed={passwordVisible}
                                    disabled={!password}
                                    onClick={togglePasswordVisibility}
                                  >
                                    <i
                                      className={`fa ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>

                                {isPasswordFocused
                                  ? validator.current.message(
                                    "Password",
                                    password,
                                    "passwordStrong"
                                  )
                                  : validator.current.message(
                                    "Password",
                                    password,
                                    "passMatch|passwordStrong"
                                  )}
                              </div>

                              <div className="fieldOuter">
                                <label htmlFor="confirmpassword">
                                  Confirm Password*
                                </label>

                                <div className="form-input-outer password-field">
                                  <input
                                    id="confirmpassword"
                                    className="form-input"
                                    placeholder="Confirm Password"
                                    type={
                                      cpasswordVisible ? "text" : "password"
                                    }
                                    name="cpassword"
                                    autoComplete="new-password"
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    value={cpassword}
                                    onFocus={() => {
                                      setIsCPasswordFocused(true);
                                      validator.current.showMessageFor(
                                        "cpassword"
                                      );
                                    }}
                                    onBlur={() => setIsCPasswordFocused(false)}
                                    onChange={(e) => {
                                      changeInput(setCPassword)(e);
                                      validator.current.showMessageFor(
                                        "cpassword"
                                      );
                                    }}
                                  />

                                  <button
                                    type="button"
                                    className="password-toggle"
                                    aria-label={cpasswordVisible ? "Hide password" : "Show password"}
                                    aria-pressed={cpasswordVisible}
                                    disabled={!cpassword}
                                    onClick={toggleCPasswordVisibility}
                                  >
                                    <i
                                      className={`fa ${cpasswordVisible ? "fa-eye-slash" : "fa-eye"}`}
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>

                                {validator.current.message(
                                  "cpassword",
                                  cpassword,
                                  isCPasswordFocused ? "passwordMatch" : "cpassMatch|passwordMatch"
                                )}
                              </div>
                              <br />

                              <div className="fieldOuter text-center mb-0 w-100">
                                <button
                                  className="primary-btn"
                                  onClick={sendOTP}
                                >
                                  CREATE AN ACCOUNT{" "}
                                  <img
                                    src="/images/web-new-images/right-arrow.svg"
                                    alt="LA"
                                  />
                                </button>
                              </div>

                              <div className="separator">
                                <span>OR</span>
                              </div>

                              <div className="google-btn">
                                <GoogleLogin
                                  text="signup_with"
                                  size="medium"
                                  width={isMobile ? "200" : "400"}
                                  onSuccess={googleSignUp}
                                  onError={() => console.log("Login Failed")}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <section className="contentOuter">
                            <div className="container">
                              <div className="row">
                                <div className="col-sm-12 registerForm">
                                  
                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Verification Code"
                                      autoComplete="one-time-code"
                                      value={otp}
                                      maxLength={10}
                                      onChange={(e) => {
                                        changeInput(setOtp)(e);
                                        validator.current.showMessageFor("otp");
                                        forceUpdate();
                                      }}
                                    />
                                    {validator.current.message(
                                      "otp",
                                      otp,
                                      "required|size:10"
                                    )}
                                    <div className="mt-1">
                                      <a
                                        href="javascript:void(0)"
                                        onClick={sendOTP1}
                                        className="text-primary"
                                        style={{ textDecoration: 'underline', fontSize: '13px' }}
                                      >
                                        Re-send Verification Code
                                      </a>
                                    </div>
                                  </Form.Group>

                                  <div className="fieldOuter text-center mb-0">
                                    <button
                                      className={otp.length !== 10 ? "primary-btn disabled" : "primary-btn"}
                                      onClick={postSignUp}
                                      disabled={otp.length !== 10}
                                    >
                                      SIGN UP
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rl-section">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="rl-content">
                  <div className="rl-outer">
                    <div className="rl-card">
                      <div>
                        <h3 className="rl-title">
                          Get our portal for your institute
                        </h3>
                        <p className="normal-text">
                          Have institute? Need portal for students?
                        </p>
                      </div>
                      <Link to="/auth/login" className="outline-btn">
                        REQUEST NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>

                  <div className="rl-outer">
                    <div className="rl-card">
                      <h3 className="rl-title">Login to NAATI CCL Portal</h3>
                      <a
                        href="https://www.laccl.languageacademy.com.au/auth/login"
                        className="outline-btn"
                      >
                        LOG IN{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </a>
                    </div>
                  </div>

                  <div className="rl-outer">
                    <div className="rl-card login-new-user">
                      <div>
                        <h3 className="rl-title">NEW USER?</h3>
                        <p className="normal-text">
                          Register now to obtain your Free Mock Test Material
                        </p>
                      </div>
                      <Link to="/auth/register" className="primary-btn">
                        Register NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Register;
